import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { SubmissionBaseQuestion } from './base-question.component';
import { EssayAnswerEditorComponent } from '../essay-answer-editor';
import { jsx as _jsx } from "react/jsx-runtime";
export var SubmissionEssayQuestion = function SubmissionEssayQuestion(props) {
  var question = props.question,
      disabled = props.disabled,
      handleUpdateEssayAnswer = props.handleUpdateEssayAnswer,
      draftAnswer = props.draftAnswer,
      answer = props.answer,
      onShowingUploadFileModal = props.onShowingUploadFileModal,
      _onShowingAudioUploadModal = props.onShowingAudioUploadModal,
      audioFile = props.audioFile,
      essayQuestionLabel = props.essayQuestionLabel,
      updateAnswerStatus = props.updateAnswerStatus,
      handleUpdateDraftEssayAnswer = props.handleUpdateDraftEssayAnswer,
      handleDeleteDraftEssayAnswer = props.handleDeleteDraftEssayAnswer,
      file = props.file,
      updateFileAnswerStatus = props.updateFileAnswerStatus,
      _props$isHideComponen = props.isHideComponent,
      isHideComponent = _props$isHideComponen === void 0 ? false : _props$isHideComponen,
      editorLabels = props.editorLabels;
  return /*#__PURE__*/_jsx(SubmissionBaseQuestion, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx(EssayAnswerEditorComponent, {
      questionId: question.id,
      questionIndex: question.index,
      readOnlyStatus: disabled,
      draftAnswer: draftAnswer,
      answer: answer,
      onUpdateAnswer: handleUpdateEssayAnswer,
      onUpdateDraftAnswer: handleUpdateDraftEssayAnswer,
      onDeleteDraftAnswer: handleDeleteDraftEssayAnswer,
      onShowingUploadModal: function onShowingUploadModal() {
        return onShowingUploadFileModal();
      },
      onShowingAudioUploadModal: function onShowingAudioUploadModal() {
        return _onShowingAudioUploadModal(audioFile);
      },
      updateAnswerStatus: updateAnswerStatus,
      label: essayQuestionLabel,
      file: file,
      updateFileAnswerStatus: updateFileAnswerStatus,
      isHideComponent: isHideComponent,
      editorLabels: editorLabels,
      audioFile: audioFile
    })
  }));
};